'use client'

import { useEffect } from 'react'

export const useInitYandexSettings = () => {
	useEffect(() => {
		window[`YandexRotorSettings`] = {
			WaiterEnabled: true,
			IsLoaded: function () {
				return document.title.length > 0
			}
		}
	}, [])
}
